
export default class Gain {
  constructor(dbs) {
    this.dbs = dbs;
  }

  static fromSliderValue(value) {
    if ( value > 1 ) {
      let offset = (value - 1.0) * 1.98;
      value = value + offset;
    }

    let dbs = (20.0 * (Math.log(value)/Math.LN10)).toFixed(1);

    return new Gain(dbs);
  }


  toGainValue() {
    return Math.pow(10, this.dbs/20);
  }

  toSliderValue() {
    let gain = this.toGainValue();
    if ( gain > 1 ) {
      // 1 -> offset is basically 0
      // 3.98 -> offset should be about 1.98
      let offset = (gain - 1) / 2.98;
      gain = 1 + offset;
    }
    return gain;
  }
}
